import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Sweet Dreams';

  playlist: string[] = ['./assets/sweet-dreams.mp4'];
  
  datatataText: any = {
    en: 'Sweet Dreams <i>performance is one of the outputs of the project Decentralized Big Data Collection, Analysis, Visualization and Interpretation in Art Practice, which is supported by Technology Agency of the Czech Republic and Brno University of Technology, Faculty of Fine Art.</i>',
    cs: 'Sweet Dreams <i>performance je jedním z výstupů projektu Decentralizovaný sběr, analýza, vizualizace a interpretace rozsáhlých dat v umělecké praxi, který je podpořen Technologickou agenturou České republiky a Fakultou výtvarných umění VUT v Brně.</i>'
  }
}
